import { motion } from "framer-motion";
import { PROCESS } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";

export default function Process() {
  return (
    <section
      data-testid="process"
      className="relative py-24 md:py-32 bg-[#111827] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Label>04 — Il metodo</Label>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 max-w-3xl">
            Tre passi. Nessuna complicazione.
          </h2>
        </Reveal>

        <div className="mt-16 space-y-4">
          {PROCESS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-70px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group grid grid-cols-12 gap-6 items-center border-t border-white/10 py-10"
            >
              <span className="col-span-12 md:col-span-2 font-display font-black text-6xl md:text-7xl text-white/10 group-hover:text-[#00C8D7]/30 transition-colors">
                {s.n}
              </span>
              <h3 className="col-span-12 md:col-span-4 font-display font-bold text-2xl md:text-3xl tracking-tight">
                {s.t}
              </h3>
              <p className="col-span-12 md:col-span-6 text-slate-400 text-lg leading-relaxed">
                {s.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
